import Outlet from "../pages/Outlet";
import Login from "../pages/Login";
import Home from "../pages/Home";
import SIM from "../pages/SIM";
import Laporan from "../pages/Laporan";
import ProtectedLayout from "./ProtectedLayout";
import Atensi from "../pages/Atensi";

export const Paths = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: <ProtectedLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/outlet", element: <Outlet /> },
      { path: "/sim", element: <SIM /> },
      { path: "/laporan", element: <Laporan /> },
      { path: "/atensi", element: <Atensi /> },
    ],
  },
];
